/* HexGuard UX layer – selective port onto live (2026-10-09): header search, desktop mega menu, mobile drill-down menu,
   mobile floating collection filter trigger. The product-page quote handler of the 2026-10-08 duplicate is not included. */
(function () {
  var root = document.documentElement;

  /* Collapse the mobile search row once the shopper scrolls, so the sticky header stays compact. */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      // hysteresis: collapsing the row shortens the sticky header (~54px) and the browser keeps the content in
      // place by lowering scrollY; a single threshold would then flip the state back and forth
      var y = window.scrollY;
      if (y > 160) root.classList.add('hg-scrolled');
      else if (y < 60) root.classList.remove('hg-scrolled');
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* The visible header field drives the existing predictive-search panel (desktop behaviour,
     now also on mobile). Tapping outside the header closes the panel again. */
  document.addEventListener('click', function (e) {
    var header = document.querySelector('.header-section');
    if (!header || !header.classList.contains('search-open')) return;
    if (header.contains(e.target)) return;
    header.classList.remove('search-open');
  });
})();

/* ---------- Mobile search: one field for the top row and the scrolled-header icon ----------
   html.hg-search-engaged keeps the header row open while the shopper uses it (focus, results open, tapping
   "Abbrechen"), also after crossing the scroll threshold. Query and results stay with the one field. */
(function () {
  var row = document.querySelector('.header-inline-search');
  var input = row && row.querySelector('.header-inline-search__input');
  if (!input) return;
  var root = document.documentElement;
  var compact = window.matchMedia('(max-width: 1067px)');
  var cancel = row.querySelector('[data-hg-search-cancel]');
  var leaveTimer = null;
  function header() { return document.querySelector('.header-section'); }
  function resultsOpen() { var h = header(); return !!h && h.classList.contains('search-open'); }
  function engage() { clearTimeout(leaveTimer); root.classList.add('hg-search-engaged'); }
  function release() { clearTimeout(leaveTimer); root.classList.remove('hg-search-engaged'); }
  function closeResults() { var h = header(); if (h) h.classList.remove('search-open'); }
  function icon() {
    var el = document.getElementById('quick-search');
    return el && el.offsetParent !== null ? el : null;
  }
  /* after scrolling the row collapses again; the visible trigger is then the search icon */
  function leave() {
    closeResults();
    release();
    if (root.classList.contains('hg-scrolled') && icon()) icon().focus({ preventScroll: true });
    else input.blur();
  }

  row.addEventListener('focusin', function () { if (compact.matches) engage(); });
  row.addEventListener('focusout', function () {
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () {
      if (row.contains(document.activeElement) || resultsOpen()) return;
      release();
    }, 250);
  });
  if (cancel) cancel.addEventListener('click', leave);
  input.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !compact.matches) return;
    if (root.classList.contains('hg-scrolled')) leave();
    else closeResults();
  });
  /* results closed elsewhere (outside tap, theme Escape handler): let the row collapse once focus has left */
  var h = header();
  if (h && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (!resultsOpen() && !row.contains(document.activeElement)) release();
    }).observe(h, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* ---------- Search while the phone menu is open (2026-10-13, Felix) ----------
   The header field stays visible above the open drawer, but its results opened behind the drawer. Focusing the
   field now closes the drawer first (same path as tapping the menu button), so the results are visible. */
(function () {
  document.querySelectorAll('.header-inline-search__input').forEach(function (input) {
    input.addEventListener('focus', function () {
      var w = document.querySelector('.mobile-toggle-wrapper');
      if (!w || !w.classList.contains('active')) return;
      var s = w.querySelector('.mobile-toggle');
      if (s) s.click();
      setTimeout(function () { input.focus({ preventScroll: true }); }, 0);
    });
  });
})();

/* ---------- Desktop navigation (snippets/hg-desktop-nav.liquid) ---------- */
(function () {
  var nav = document.querySelector('.hg-nav');
  if (!nav) return;
  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-hg-nav-item].has-panel'));
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openTimer = null, closeTimer = null;

  function setOpen(item, open, how) {
    var btn = item.querySelector('.hg-nav__toggle');
    item.classList.toggle('is-open', open);
    if (open) item.setAttribute('data-hg-open-by', how || 'click');
    else item.removeAttribute('data-hg-open-by');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except) { items.forEach(function (it) { if (it !== except) setOpen(it, false); }); }

  /* menu images are loading="lazy" (no bytes on phones or before a panel opens); on hover/focus intent the
     item's panel images switch to eager, so they load during the open delay and do not pop in */
  function prewarm(item) {
    if (item.hasAttribute('data-hg-warm')) return;
    item.setAttribute('data-hg-warm', '');
    item.querySelectorAll('.hg-panel img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.hg-nav__toggle');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(openTimer);
      prewarm(item);
      var isOpen = item.classList.contains('is-open');
      // a pointer click on the arrow of a panel that hover just opened keeps it open (it used to close it again)
      var keep = isOpen && e.detail > 0 && item.getAttribute('data-hg-open-by') === 'hover';
      var open = keep ? true : !isOpen;
      closeAll(item); setOpen(item, open, 'click');
    });
    item.addEventListener('mouseenter', function () {
      if (!hoverCapable.matches) return;
      prewarm(item);
      clearTimeout(closeTimer); clearTimeout(openTimer);
      // intent delay: a panel that is already open switches faster than a fresh opening
      var anyOpen = items.some(function (it) { return it.classList.contains('is-open'); });
      if (item.classList.contains('is-open')) return;
      openTimer = setTimeout(function () { closeAll(item); setOpen(item, true, 'hover'); }, anyOpen ? 140 : 260);
    });
    item.addEventListener('mouseleave', function () {
      if (!hoverCapable.matches) return;
      clearTimeout(openTimer);
      // close every panel: a quick sweep across the bar must not leave an earlier panel open
      closeTimer = setTimeout(function () { closeAll(); }, 280);
    });
    item.addEventListener('focusin', function () { prewarm(item); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        setOpen(item, false);
        if (btn) btn.focus();
      }
    });
    item.addEventListener('focusout', function (e) {
      if (item.contains(e.relatedTarget)) return;
      // focus lost to nothing (e.g. a click on blank panel space) while the pointer is still over the item: keep it open
      if (!e.relatedTarget && hoverCapable.matches && item.matches(':hover')) return;
      setOpen(item, false);
    });
  });
  document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });

  /* Selector layout (e.g. Tiervergrämung): a vertical tab list with a roving tabindex. Only the selected animal is in
     the Tab order; Up/Down/Home/End move and select; Tab continues into the visible pane. Hover selects after a short
     dwell (diagonal moves towards the pane do not switch animals), click and keyboard select at once. */
  nav.querySelectorAll('[data-hg-selector]').forEach(function (sel) {
    var btns = Array.prototype.slice.call(sel.querySelectorAll('[data-hg-select]'));
    var dwell = null;
    function pick(b) {
      clearTimeout(dwell);
      btns.forEach(function (x) {
        var on = x === b;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.setAttribute('tabindex', on ? '0' : '-1');
        var pane = document.getElementById(x.getAttribute('data-hg-select'));
        if (pane) pane.hidden = !on;
      });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('focus', function () { if (b.getAttribute('aria-selected') !== 'true') pick(b); });
      b.addEventListener('mouseenter', function () {
        if (!hoverCapable.matches) return;
        clearTimeout(dwell);
        dwell = setTimeout(function () { pick(b); }, 120);
      });
      b.addEventListener('mouseleave', function () { clearTimeout(dwell); });
      b.addEventListener('keydown', function (e) {
        var to = null;
        if (e.key === 'ArrowDown') to = btns[(i + 1) % btns.length];
        else if (e.key === 'ArrowUp') to = btns[(i - 1 + btns.length) % btns.length];
        else if (e.key === 'Home') to = btns[0];
        else if (e.key === 'End') to = btns[btns.length - 1];
        if (!to) return;
        e.preventDefault();
        pick(to);
        to.focus();
      });
    });
  });
})();

/* ---------- Mobile drill-down menu ----------
   The handler now sits inline right after the drawer (snippets/header-mobile-menu.liquid), so department taps work
   before this deferred file has loaded, and also with the HexGuard UX setting off. */

/* ---------- Mobile collection pages: floating "Filtern und sortieren" ----------
   Uses the theme's own trigger #Facets-Toggle (assets/facets.js opens #Facet-Drawer); CSS floats it on phones.
   Here only: state for assistive tech, focus into the drawer and back to the trigger, and hiding while the footer
   or the cookie banner is visible. No second trigger, no second listener on the drawer logic. */
(function () {
  var body = document.body;
  var toggle = document.getElementById('Facets-Toggle');
  var drawer = document.getElementById('Facet-Drawer');
  if (!toggle || !drawer || !body.classList.contains('template-collection')) return;
  body.classList.add('hg-filter-float');
  toggle.setAttribute('role', 'button');
  toggle.setAttribute('aria-controls', 'Facet-Drawer');
  toggle.setAttribute('aria-expanded', 'false');
  // role=button on a link: Space must activate it too (facets.js only listens for click); without this Space scrolled the page
  toggle.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    e.preventDefault();
    toggle.click();
  });
  var wasOpen = false;
  new MutationObserver(function () {
    var open = drawer.classList.contains('active');
    if (open === wasOpen) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      // move focus into the drawer (its close control) so keyboard users continue there
      var first = drawer.querySelector('side-panel-close, .side-panel-close, button, [href], input, select');
      if (first) { if (!first.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT)$/.test(first.tagName)) first.setAttribute('tabindex', '-1'); setTimeout(function () { first.focus({ preventScroll: true }); }, 60); }
    } else {
      var a = document.activeElement;
      if (!a || a === body || drawer.contains(a)) toggle.focus({ preventScroll: true });
    }
    wasOpen = open;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  // never cover footer links: hide while the footer is on screen
  var footer = document.querySelector('#shopify-section-footer, .shopify-section-group-footer-group, footer');
  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      body.classList.toggle('hg-footer-in-view', entries.some(function (en) { return en.isIntersecting; }));
    }).observe(footer);
  }
  // never cover the cookie banner's actions
  function syncConsent() {
    var b = document.getElementById('shopify-pc__banner');
    // the banner is position:fixed (offsetParent is always null for fixed elements) – use size + computed style
    var cs = b ? getComputedStyle(b) : null;
    var shown = !!b && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0 && b.getBoundingClientRect().height > 0;
    body.classList.toggle('hg-consent-open', shown);
    return shown;
  }
  syncConsent();
  document.addEventListener('visitorConsentCollected', function () { setTimeout(syncConsent, 50); });
  // the banner is inserted/removed by Shopify's privacy script: watch body children, then the banner itself
  var watched = null;
  function watch() {
    var b = document.getElementById('shopify-pc__banner');
    if (b && b !== watched && 'MutationObserver' in window) {
      watched = b;
      new MutationObserver(syncConsent).observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
    }
    syncConsent();
  }
  if ('MutationObserver' in window) new MutationObserver(watch).observe(body, { childList: true });
  watch();
  document.addEventListener('click', function () { setTimeout(syncConsent, 300); }, true);
})();
